import { IAuthState } from '@/@types'
import CONSTANTS from '@/constants'

const state: IAuthState = {
  isAuthenticated: false,
  userProfile: {
    account_id: '',
    user_id: '',
    mfa_required: null,
    avatar: '',
    mfa_method: null,
    preferred_phone_number: null,
    email: '',
    first_name: '',
    last_name: '',
    recaptcha: '',
  },
  userLeadAlias: '',
  authProviders: CONSTANTS.AUTH_PROVIDERS,
  isTwoFactorRequired: false,
}

export default state
